import { render, staticRenderFns } from "./contractDetailRoom.vue?vue&type=template&id=4b4bc9de&scoped=true"
import script from "./contractDetailRoom.vue?vue&type=script&lang=js"
export * from "./contractDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./contractDetailRoom.vue?vue&type=style&index=0&id=4b4bc9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bc9de",
  null
  
)

export default component.exports